<div class="d-flex flex-column align-items-center scale-{{ scale }}">
  <img class="mb-5" [src]="logo" alt="">
  <div class="loader"></div>
  <small>
    @if (isTimeout) {
      <span>การโหลดใช้เวลานานเกินไป</span>
      <button pButton label="ปิด" class="rounded-pill p-button-danger ml-2" (click)="onTimeout()"></button>
    }
    @if (!isTimeout) {
      กรุณารอสักครู่...
    }
  </small>
</div>